import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Swal from 'sweetalert2';
import {
  Checkbox,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  InputLabel,
  Radio,
  FormControl,
  Select,
  MenuItem,
  Box,
  Typography,
} from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import request from '../../../services/Request';
import { Modal } from '../../../components/BootstrapToMUI';

const updateAlert = '/logs/updateAlertCustom';

export default function AlertCustomModal(props) {
  const {
    reset,
    handleSubmit,
    setValue,
    register,
    watch,
    setError,
    control,
    formState: { errors },
  } = useForm({});
  const { data, id, setReFresh, reFresh, ...rest } = props;
  const watchAll = watch();

  useEffect(() => {
    const initializeForm = async () => {
      reset({
        code: data.code,
        text: data.text,
        alert: data.alert,
        color: data.color,
      });
    };
    initializeForm();
  }, [data]);

  const color = ['grey', 'blue', 'red'];

  const onSubmit = async (formData) => {
    console.log(formData);
    await request({
      method: 'post',
      url: updateAlert,
      data: {
        _id: data._id,
        code: formData.code,
        text: formData.text,
        alert: formData.alert,
        color: formData.color,
        referTo: id,
      },
    }).then((res) => {
      Swal.fire({
        text: `Your changes has been updated!`,
        icon: 'success',
      }).then(() => {
        setReFresh(!reFresh);
        props.onHide();
      });
    });
  };

  return (
    <Modal className="modal-w" {...rest} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" style={{ fontSize: '1.2rem' }}>
          Update Settings
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box>
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Code"
                    {...register('code', {})}
                    disabled={true}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Message Text"
                    {...register('text', {})}
                  />
                </Grid>

                <Grid item xs={7}>
                  <Controller
                    render={({ field }) => (
                      <FormControl fullWidth variant="outlined">
                        <InputLabel>Color</InputLabel>
                        <Select
                          fullWidth
                          label="Color"
                          defaultValue="grey"
                          {...field}
                          variant="outlined"
                        >
                          {color.map((e, index) => {
                            return (
                              <MenuItem key={index} value={e}>
                                {e}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    )}
                    name="color"
                    control={control}
                  />
                </Grid>

                <Grid
                  item
                  xs={5}
                  sx={{
                    display: 'flex',
                    alignContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Controller
                    name="alert"
                    control={control}
                    render={({ field }) => <Checkbox {...field} checked={watchAll.alert} />}
                  />
                  <Typography variant="body1">Email Alert</Typography>
                </Grid>
              </Grid>

              <Button
                sx={{ mt: 2.5 }}
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
              >
                Update
              </Button>
            </form>
          </Box>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
